import { createNode, PlainDateTimeDataType, PlainTimeDataType } from '@glueapp/graph-types';
import { toPlainDateTime, fromPlainTime } from '../../utils/temporal';

export const DateTimeToTime = createNode({
    id: 'DateTime to Time',
    name: 'DateTime to Time',
    description: 'Extracts the Time portion from a DateTime, discarding the date',
    aiDescription:
        'Takes a DateTime on the "DateTime" port and outputs just the Time portion on the "Time" port, discarding the date component.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        DateTime: PlainDateTimeDataType,
    },
    outPorts: {
        Time: PlainTimeDataType,
    },
    execute: function (input) {
        const dateTime = toPlainDateTime(input.inPorts.DateTime);
        return { output: { Time: fromPlainTime(dateTime.toPlainTime()) } };
    },
});
